import React, { useState } from 'react';
import NavSubBar from '../NavBarElementsDropdown/NavSubBar';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import EnSavoirPlus from '../NavBarElementsDropdown/EnSavoirPlus';
import { Button, Menu, MenuHandler } from '@material-tailwind/react';
import { ChevronDown } from 'lucide-react';
import ExploreDropdown from './ExploreDropDown';
import SearchButton from './SearchButton';

const menuItems = [
    { name: 'En savoir plus' },
];

function NavBarHome() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    let authToken = localStorage.getItem('auth_token');

    return (
        <nav className="fixed top-0 left-0 w-full right-0 z-[100] px-4 md:px-6 items-center bg-white shadow-sm">
            <div className="w-full h-[70px] md:h-[92px] flex items-center justify-between">
                <div className="flex items-center gap-4 md:gap-6">
                    <a href="/" className="flex items-center">
                        {/* Logo pour le mode light */}
                        <img
                            src="/Logo NextMaker.png"
                            alt="logo"
                            className="h-8 md:h-[35px] block dark:hidden"
                        />
                    </a>

                    <div className="hidden md:block">
                        <ExploreDropdown buttonColor="text-blue-1" />
                    </div>

                </div>

                <div className="hidden md:block">
                    <NavSubBar textColor="text-blue-1" />
                </div>

                {/* Menu desktop */}
                <div className="hidden md:flex items-center gap-4">
                    <SearchButton />
                    {authToken ? (
                        <a href="https://app.gonextmaker.com">
                            <button className="h-[50px] px-[30px] bg-purple-1 border-2 border-purple-1
                            rounded-full font-medium text-white hover:bg-transparent hover:text-purple-1 transition-colors">
                                Dashboard
                            </button>
                        </a>
                    ) : (
                        <a href="https://app.gonextmaker.com/auth/signup">
                            <button className="h-[50px] px-[30px] bg-red-4 border-2 border-red-4 text-button
                    rounded-full font-medium text-white hover:bg-transparent hover:text-red-4 transition-colors">
                                Rejoindre
                            </button>
                        </a>
                    )}
                </div>

                {/* Menu mobile - Hamburger icon */}
                <div className="md:hidden flex items-center gap-3">
                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="p-2 text-dark-1 dark:text-white"
                    >
                        {isMobileMenuOpen ? (
                            <XMarkIcon className="h-6 w-6" />
                        ) : (
                            <Bars3Icon className="h-6 w-6" />
                        )}
                    </button>
                </div>
            </div>

            {/* Menu mobile dépliant */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white dark:bg-dark-2 border-t border-gray-200 dark:border-gray-700 py-4 px-4">
                    <div className="flex flex-col space-y-4">
                        <div className="py-2">
                            <NavSubBar
                                textColor="text-dark-1 dark:text-white"
                                mobile={true}
                                orientation="vertical"
                            />
                        </div>

                        <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                            {menuItems.map((item) => (
                                <Menu key={item.name} placement={isMobileMenuOpen ? "bottom-start" : "bottom-start"}>
                                    <MenuHandler>
                                        <Button
                                            variant="text"
                                            className={`flex items-center text-sm text-dark-1 dark:text-white hover:text-purple-1
                            ${isMobileMenuOpen ? 'justify-between w-full py-2' : 'px-1'}`}
                                        >
                                            <a className='font-light text-[12px] dark:hover:text-purple-300' href={item.link}>{item.name}</a>
                                            {(item.name === 'En savoir plus') && (
                                                isMobileMenuOpen ? (
                                                    <ChevronDown size={20} className="ml-2 transition-transform duration-200 group-hover:rotate-180" />
                                                ) : (
                                                    <ChevronDown size={20} className="transition-transform duration-200 group-hover:rotate-180" />
                                                )
                                            )}
                                        </Button>
                                    </MenuHandler>
                                    <EnSavoirPlus mobile={isMobileMenuOpen} />
                                </Menu>
                            ))}
                            {authToken ? (
                                <a href="https://app.gonextmaker.com">
                                    <button className="w-full mt-2 h-[44px] bg-purple-1 border-2 border-purple-1
                            rounded-full font-medium text-white hover:bg-transparent hover:text-purple-1 transition-colors">
                                        Dashboard
                                    </button>
                                </a>
                            ) : (
                                <a href="https://app.gonextmaker.com/auth/signup" onClick={() => setIsMobileMenuOpen(false)}>
                                    <button className="w-full mt-2 h-[44px] bg-red-4 border-2 border-red-4 text-button
                                        rounded-full font-medium text-white hover:bg-transparent hover:text-red-4
                                        transition-colors">
                                        Rejoindre
                                    </button>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
}

export default NavBarHome;